import ApiService from "@/core/services/api.service";
import {SET_SNACK} from "@/core/services/store/snackbar.module";

// action types
export const POSTS_LIST = "posts_list";
export const POSTS_SIMPLE_LIST = "posts_simple_list";
export const CREATE_POST = "create_post";
export const UPDATE_POST = "update_post";
export const UPDATE_POST_STATUS = "UPDATE_POST_STATUS";
export const DELETE_POST = "delete_post";
export const GET_POST_DETAILS = "get_post_details";
export const CLEAR_POST_ERRORS = "clearPostErrors";

// mutation types
export const SET_POST_ERROR = "setPostError";
export const REMOVE_POST_ERRORS = "removePostErrors";

const state = {
    errors: null
};


const actions = {
    [POSTS_LIST](context, payload) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.datatable("api/posts?" + payload.q + payload.columns.join(''))
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                        context.commit(SET_POST_ERROR, data.errors);
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_POST_ERROR, response.errors);
                });
        });
    },
    [POSTS_SIMPLE_LIST]() {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.get("api/postssimple")
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    }
                });
        });
    },
    [GET_POST_DETAILS](context, id) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.get("api/getpostdetail", id)
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                        context.commit(SET_POST_ERROR, data.errors);
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_POST_ERROR, response.errors);
                });
        });
    },
    [CREATE_POST](context, payload) {
        return new Promise(resolve => {
            return ApiService.post("api/createpost", payload.data).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_POST_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_POST_ERROR, response.errors);
                });
        });
    },
    [UPDATE_POST](context, payload) {
        return new Promise(resolve => {
            return ApiService.update("api/updatepost", payload.slug, payload.data).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_POST_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_POST_ERROR, response.errors);
                });
        });
    },
    [UPDATE_POST_STATUS](context, payload) {
        return new Promise(resolve => {
            return ApiService.update("api/updatepoststatus", payload.slug, payload.data).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_POST_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_POST_ERROR, response.errors);
                });
        });
    },
    [DELETE_POST](context, payload) {
        return new Promise(resolve => {
            return ApiService.post("api/deletepost", payload).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_POST_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_POST_ERROR, response.errors);
                });
        });
    },
    [CLEAR_POST_ERRORS](context) {
        context.commit(REMOVE_POST_ERRORS);
    },
};

const mutations = {
    [SET_POST_ERROR](state, error) {
        state.errors = error;
    },
    [REMOVE_POST_ERRORS](state) {
        state.errors = {};
    }
};

export default {
    state,
    actions,
    mutations
};
